module.exports = __webpack_public_path__ + "static/021-88ad1579ae3daf8171556668ef45dd93.jpg";